import type * as React from 'react';
import { post, put } from '@Domain/Api';
import subjectTypeDefinitionSaved, {
	type SubjectTypeDefinitionSavedAction,
} from '@Application/SubjectTypeDefinitions/Actions/subjectTypeDefinitionSaved';
import subjectTypeDefinitionSaveFailed, {
	type SubjectTypeDefinitionSaveFailedAction,
} from '@Application/SubjectTypeDefinitions/Actions/subjectTypeDefinitionSaveFailed';
import type { SubjectTypeDefinitionPayload } from '@Application/SubjectTypeDefinitions/Actions/subjectTypeDefinitionsFetched';
import type SaveSubjectTypeDefinition from '@Application/SubjectTypeDefinitions/Commands/SaveSubjectTypeDefinition';
import extractMessages from '@Infra/FetchLib/ApiError/extractMessages';
import parameters from '../../parameters';

type Actions = SubjectTypeDefinitionSavedAction | SubjectTypeDefinitionSaveFailedAction;

export default (command: SaveSubjectTypeDefinition) => {
	return async (dispatch: React.Dispatch<Actions>): Promise<Actions> => {
		try {
			const baseUrl = `${parameters.api.host}/api/accounts/${command.accountId}/subject-type-definitions`;
			const payload =
				command.id === null
					? await post<SubjectTypeDefinitionPayload>(baseUrl, command.toJSON())
					: await put<SubjectTypeDefinitionPayload>(`${baseUrl}/${command.id}`, command.toJSON());

			const action = subjectTypeDefinitionSaved(payload, command.accountId);
			dispatch(action);
			return action;
		} catch (error) {
			const action = subjectTypeDefinitionSaveFailed(extractMessages(error));
			dispatch(action);
			return Promise.reject(action);
		}
	};
};
